import React from 'react'
import styled from 'styled-components'

// RailFooter component for displaying rail footer.
const RailFooter = ({ logo, title, time, nextP }) => {
  // let logoS = "https://pmd205470tn-a.akamaihd.net/D2C_Partner_-_Diagnal_Sales_Demo_(ERA_3.0)/477/945/SixxAT__347030.png"
  return (
    <RailFooterStyled className={nextP ? 'next-program' : ''} >
      <div className="program-details">
        <div className="program-details__title">{title}</div>
        <div className="program-details__time">{time}</div>
      </div>
      <div className="program-status">
           { !nextP ? <div className="on-now">On Now</div> :
            <div className="next-text">Next</div> }
      </div>

    </RailFooterStyled>
  )
}


const RailFooterStyled = styled.div`
display: flex;
flex-direction: row;
align-content: center;
width: 100%;
background-color : #222222;
border-bottom: 1px solid #7B7B7B;
position: absolute;
left: 0;
z-index: 1;
height: 60px;
top: calc(100% + 20px);

.program-details{
   margin-left: 10px;
   margin-right: auto;
   margin-top: auto;
   margin-bottom: auto;
   width: 50%;

  .program-details__title{
    font-size: 16px;
    color: white;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;

  }//program-details__title
  
  .program-details__time{
    font-size: 12px;
    color: grey;
    margin-top: 5px;

  }//program-details__time

}//program-details

.program-status{
  margin-top: auto;
  margin-left: auto;
  margin-right: 10px;
  margin-bottom: 20px;
  max-width: 50%;

  .on-now{
    color: black;
    background-color: yellow;
    font-size: 12px;
    margin-bottom: 10px;
    right: 0;
    padding: 2px 4px;
    font-weight: 900;
  }//on-now
  .next-text{
    color: grey;
    font-size: 12px;
    margin-bottom: 10px;
    right: 0;
    padding: 2px 4px;
    font-weight: 600;
  }
}//program-status



 




 .logo{
   height: 80%;
   padding: 10px;
 }
`


export default RailFooter